var BACKEND_URL = "https://localhost:3001/";
if (process.env.NODE_ENV.indexOf('production') > -1)
  BACKEND_URL = "https://api.sainer.pl/";
export const ROOT_BACKEND_URL = BACKEND_URL;